import FAQAccordion from "@/components/sections/FAQAccordion";
import { Link } from "react-router-dom";
import { flatFaqs } from "@/data/faqs";

export default function FAQPage() {
  return (
    <div data-testid="page-faq">
      <section className="py-20 md:py-24 hero-grid-bg">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#00A651] mb-4">FAQ</div>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tighter text-[#1F1E4E] leading-[1.05]">
            Everything you wanted to know.
          </h1>
          <p className="mt-5 text-lg text-slate-600">{flatFaqs.length}+ answers on ClockedIn HRM, features, security, pricing and more.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <FAQAccordion showCategories />
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h3 className="text-2xl font-extrabold text-[#1F1E4E]">Still have questions?</h3>
          <Link to="/contact" data-testid="faq-contact-cta" className="inline-flex mt-5 bg-[#00A651] hover:bg-[#008A43] text-white font-bold rounded-lg px-6 py-3">Talk to Sales</Link>
        </div>
      </section>
    </div>
  );
}
